<template >
  <v-layout>
    <v-panel
      contextual-style="primary"
    >
      <h1 class="panel-title" slot="heading">
        List Management
      </h1>
      <div slot="body">

        <table class="table">
          <thead>
            <tr>
              <th>List Name</th>
              <th>List Type</th>
              <th>List Description</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:class="{'editable': listname.type !== 'global'}" @click="selectList(listname)" v-for="listname in $store.state.lists.all_lists">
              <td>{{ listname.name }}</td>
              <td>{{ listname.type }}</td>
              <td>{{ listname.description }}</td>
              <td v-bind:class="{ green: listname.enabled, red: !listname.enabled }">{{ listname.enabled ? 'ACTIVE' : 'INACTIVE' }}<span class="readonly" v-if="listname.type === 'global'">&nbsp(readonly)</span></td>
            </tr>
          </tbody>
        </table>

      </div>
    </v-panel>
  </v-layout>
</template>
<script>

import Vue from 'vue';
import listService from '../../../services/list';
import store from './../../../store';

export default {
  data() {
    return {
      formdata: {
      },
    };
  },
  methods: {
    refresh() {
      listService.getsplists();
//      listService.getall();
    },
    selectList(newlistid) {
      if (newlistid && newlistid.type) {
        if (newlistid.type === 'global') {
          return;
        }
      }
      Vue.router.push({
        name: 'lists.edit',
        params: {
          listid: newlistid.list_id,
        },
      });
    },
  },
  beforeMount() {
    listService.getsplists(store.state.auth.selected_sp.sp_id);
//    listService.getall();
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};

</script>
<style>
tr.editable:hover {
  background: #eeeef2;
  /*cursor:context-menu;*/
  cursor:pointer;
}
td.green {
  color: #00aa00;
}
span.readonly {
  color: #aaaaaa;
}
td.red {
  color: #aa0000;
}
</style>



// WEBPACK FOOTER //
// index.vue?44237b76